import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _regeneratorRuntime from "@babel/runtime/helpers/esm/regeneratorRuntime";
import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _class, _templateObject;
import { GlobalDocument } from "../GlobalDocument";
import { GlobalSetting } from "../GlobalSetting";
import { GlobalTask } from "../GlobalTask";
import { SimpleFooter } from "../SimpleFooter";
import { SuperHeader, SuperHeaderAvatar, SuperHeaderSitemap } from "../SuperHeader";
import { SuperRootContainer } from "../SuperRootContainer";
import { SuperTitle } from "../SuperTitle";
import { BookOutlined, DesktopOutlined, MenuFoldOutlined, MenuUnfoldOutlined, SettingOutlined } from '@ant-design/icons';
import { gql } from '@apollo/client';
import { EnforcerAdapter } from '@element/beryllium';
import { DEFAULT_ICON_CONFIGS } from '@icon-park/react';
import * as Sentry from '@sentry/react';
import Avatar from 'boring-avatars';
import dayjs from 'dayjs';
import dayjsTimezone from 'dayjs/plugin/timezone';
import dayjsUTC from 'dayjs/plugin/utc';
import _ from 'lodash';
import React from 'react';
import { Logger } from "./logger";
import { Requester } from "./requester";
import { Translator } from "./translator";
export var Generator = /*#__PURE__*/_createClass(function Generator() {
  _classCallCheck(this, Generator);
});
_class = Generator;
_defineProperty(Generator, "forAccess", EnforcerAdapter.forOxygen.bind(EnforcerAdapter));
_defineProperty(Generator, "forApp", function (options) {
  // 初始化上下文
  // > 输出信息
  // > > 欢迎信息
  Logger.colorful('Hello, JiShuXin!');
  // > > 版本信息
  Logger.capsule('Two Factor Technology > Element > Oxygen', 'Build20250325.LX');
  // > 修复 IconPark 图标在 AntDesign 环境中的展示问题
  DEFAULT_ICON_CONFIGS.prefix = "".concat('antIcon'.toLowerCase(), " i");
  // > 扩展 Day.js
  // > > -
  dayjs.extend(dayjsUTC);
  // > > -
  dayjs.extend(dayjsTimezone);
  // 构建并返回数据
  return {
    getInitialState: function () {
      var _getInitialState = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _settings$_, _options$getInitialSt;
        var settings, initialState;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return fetch('/statics/configurations/core.json').then(function (response) {
                return response.json();
              }).catch(console.error);
            case 2:
              settings = _context2.sent;
              // > 初始化翻译
              Translator.initialize();
              // > 初始化请求器
              // > > -
              Requester.initialize();
              // > > -
              Requester.instanceMetadata.baseURL = settings.request.baseURL;
              // > 初始化 Sentry
              if ((_settings$_ = settings._) !== null && _settings$_ !== void 0 && _settings$_.sentry) {
                try {
                  Sentry.init(_objectSpread({
                    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
                    replaysOnErrorSampleRate: 1.0,
                    replaysSessionSampleRate: 0.1,
                    tracePropagationTargets: [Requester.instanceMetadata.baseURL],
                    tracesSampleRate: 1.0
                  }, settings._.sentry));
                } catch (_unused) {}
              }

              // 构建初始状态
              // > 获取扩展状态
              _context2.next = 9;
              return (options === null || options === void 0 || (_options$getInitialSt = options.getInitialState) === null || _options$getInitialSt === void 0 ? void 0 : _options$getInitialSt.call(options)) || Promise.resolve({});
            case 9:
              initialState = _context2.sent;
              _context2.t0 = _;
              _context2.t1 = {
                settings: {
                  layout: {
                    // 确保一定有一个名称
                    title: 'Oxygen'
                  }
                }
              };
              _context2.t2 = settings;
              _context2.next = 15;
              return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
                return _regeneratorRuntime().wrap(function _callee$(_context) {
                  while (1) switch (_context.prev = _context.next) {
                    case 0:
                      if (!initialState.user) {
                        _context.next = 4;
                        break;
                      }
                      return _context.abrupt("return", initialState.user);
                    case 4:
                      _context.next = 6;
                      return Requester.instance.query({
                        errorPolicy: 'all',
                        query: gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n                      query GetCurrentAccount {\n                        palmier {\n                          user {\n                            current {\n                              id\n                              uuid\n                              email\n                              nickName\n                              name\n                              avatar {\n                                url\n                              }\n                              phone\n                              policies {\n                                payload\n                              }\n                              userGroups {\n                                policies {\n                                  payload\n                                }\n                              }\n                            }\n                          }\n                        }\n                      }\n                    "])))
                      }).then(function (payload) {
                        return payload.data.palmier.user.current;
                      }).catch(console.error);
                    case 6:
                      return _context.abrupt("return", _context.sent);
                    case 7:
                    case "end":
                      return _context.stop();
                  }
                }, _callee);
              }))();
            case 15:
              _context2.t3 = _context2.sent;
              _context2.t4 = {
                settings: _context2.t2,
                user: _context2.t3
              };
              _context2.t5 = initialState;
              return _context2.abrupt("return", _context2.t0.merge.call(_context2.t0, _context2.t1, _context2.t4, _context2.t5));
            case 19:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      function getInitialState() {
        return _getInitialState.apply(this, arguments);
      }
      return getInitialState;
    }(),
    layout: function layout() {
      var _initialState$user, _initialState$user2, _initialState$user3, _initialState$setting, _options$layout;
      for (var _len = arguments.length, layoutOptions = new Array(_len), _key = 0; _key < _len; _key++) {
        layoutOptions[_key] = arguments[_key];
      }
      // 构建
      // > -
      var initialState = layoutOptions[0].initialState;
      // > -
      var layout0 = _.merge({
        layout: 'mix',
        splitMenus: true,
        menu: {
          locale: false,
          collapsedShowGroupTitle: true
        },
        logo: /*#__PURE__*/React.createElement(SuperHeaderSitemap, null),
        onMenuHeaderClick: function onMenuHeaderClick(event) {
          return event.preventDefault();
        },
        avatarProps: {
          size: 24,
          title: initialState === null || initialState === void 0 || (_initialState$user = initialState.user) === null || _initialState$user === void 0 ? void 0 : _initialState$user.name,
          src: /*#__PURE__*/React.createElement(Avatar, {
            size: 24,
            variant: "beam",
            name: (initialState === null || initialState === void 0 || (_initialState$user2 = initialState.user) === null || _initialState$user2 === void 0 ? void 0 : _initialState$user2.name) || 'root',
            colors: ['#C4DDD6', '#D4DDD6', '#E4DDD6', '#E4E3CD', '#ECECDD']
          }),
          render: function render(properties, element) {
            return /*#__PURE__*/React.createElement(SuperHeaderAvatar, properties, element);
          }
        },
        waterMarkProps: {
          content: initialState === null || initialState === void 0 || (_initialState$user3 = initialState.user) === null || _initialState$user3 === void 0 ? void 0 : _initialState$user3.name
        },
        footerRender: function footerRender() {
          return /*#__PURE__*/React.createElement(SimpleFooter, null);
        },
        appList: [],
        token: {
          // colorPrimary: 'rgba(19, 194, 194, 1)',
          sider: {
            colorMenuBackground: 'rgba(255, 255, 255, 1)'
          },
          header: {
            // 这里需要配合 global.less 强制做一些修改来使用
            heightLayoutHeader: 48 + 56,
            colorBgHeader: 'rgba(255, 255, 255, 1)'
          },
          pageContainer: {
            // 不要在这里修改 PageContainer 的 padding, 会有意外的样式错误
            colorBgPageContainer: 'rgba(255, 255, 255, 1)'
          }
        },
        menuExtraRender: SuperTitle,
        collapsedButtonRender: function collapsedButtonRender(collapsed, defaultElement) {
          return /*#__PURE__*/React.createElement("div", {
            style: {
              width: 'calc(100% + 2 * 8px)',
              borderTop: '1px solid #DBDDE0',
              padding: '12px 0',
              textAlign: 'center',
              cursor: 'pointer',
              height: 40,
              marginInline: -8
            },
            onClick: defaultElement.props.onClick
          }, collapsed ? /*#__PURE__*/React.createElement(MenuUnfoldOutlined, null) : /*#__PURE__*/React.createElement(MenuFoldOutlined, null));
        },
        menuRender: function menuRender(properties, element) {
          // -
          var prefix = window.location.pathname.split('/').slice(0, 3).join('/');
          // -
          return /*#__PURE__*/React.cloneElement(element, {
            menu: _objectSpread(_objectSpread({}, properties.menu), {}, {
              type: 'group'
            }),
            menuData: element.props.menuData.filter(function (item) {
              return item.path === prefix;
            }).reduce(function (previousValue, currentValue) {
              return [].concat(_toConsumableArray(previousValue), _toConsumableArray(currentValue.children || []));
            }, [])
          });
        },
        headerRender: function headerRender(_properties_, element) {
          return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SuperHeader, null), /*#__PURE__*/React.cloneElement(element, {
            matchMenuKeys: []
          }));
        }
      }, initialState === null || initialState === void 0 || (_initialState$setting = initialState.settings) === null || _initialState$setting === void 0 ? void 0 : _initialState$setting.layout, _objectSpread(_objectSpread({
        title: false
      }, options === null || options === void 0 || (_options$layout = options.layout) === null || _options$layout === void 0 ? void 0 : _options$layout.apply(_class, layoutOptions)), {}, {
        actionsRender: function actionsRender(properties) {
          var _options$layout2, _options$layout2$acti;
          return [properties.isMobile && /*#__PURE__*/React.createElement(DesktopOutlined, {
            key: "desktop"
          }), /*#__PURE__*/React.createElement(GlobalTask, {
            key: "task"
          }), /*#__PURE__*/React.createElement(GlobalDocument, {
            key: "document",
            trigger: /*#__PURE__*/React.createElement(BookOutlined, null)
          }), /*#__PURE__*/React.createElement(GlobalSetting, {
            key: "setting",
            trigger: /*#__PURE__*/React.createElement(SettingOutlined, null)
          }), options === null || options === void 0 || (_options$layout2 = options.layout) === null || _options$layout2 === void 0 || (_options$layout2 = _options$layout2.apply(_class, layoutOptions)) === null || _options$layout2 === void 0 || (_options$layout2$acti = _options$layout2.actionsRender) === null || _options$layout2$acti === void 0 ? void 0 : _options$layout2$acti.call(_options$layout2, properties)];
        }
      }));
      // 返回
      // @ts-expect-error
      if (window.__POWERED_BY_QIANKUN__) {
        return _.merge(layout0, {
          actionsRender: function actionsRender() {
            return [];
          },
          menuHeaderRender: false,
          layout: 'side'
        });
      } else {
        return layout0;
      }
    },
    locale: _.merge({
      onError: function onError() {}
    }, options === null || options === void 0 ? void 0 : options.locale),
    /**
     * @see https://umijs.org/gu-IN/plugins/plugin-request
     **/
    request: _.merge({
      timeout: Math.pow(2, 16),
      withCredentials: true,
      // 请求拦截器
      requestInterceptors: [Requester.handleRequest.bind(Requester)],
      // 响应拦截器
      responseInterceptors: [Requester.handleResponse.bind(Requester)]
    }, options === null || options === void 0 ? void 0 : options.request),
    rootContainer: function rootContainer(container) {
      return /*#__PURE__*/React.createElement(SuperRootContainer, null, container);
    }
  };
});